<template>
    <div class="chatFilter">
      <div class="filterItem leftend">
        <i class="fa fa-filter" aria-hidden="true"></i>
      </div>
      <div class="filterItem clickable" :class="{active: currentStatusFilter === 'all'}"
           @click="applyStatusFilter('all')">
        <i class="fa fa-comments" aria-hidden="true"></i>
        <p>alle Chats ({{ allCount }})</p></div>
      <div class="filterItem clickable" :class="{active: currentStatusFilter === 'open'}"
           @click="applyStatusFilter('open')">
        <i class="fa fa-circle circle-orange" aria-hidden="true"></i>
        <p>offene Chats ({{ openCount }})</p>
      </div>
      <div class="filterItem clickable" :class="{active: currentStatusFilter === 'processed'}"
           @click="applyStatusFilter('processed')">
        <i class="fa fa-circle online" aria-hidden="true"></i>
        <p>in Bearbeitung ({{ processedCount }})</p>
      </div>
      <div class="filterItem clickable rightend" :class="{active: currentStatusFilter === 'closed'}"
           @click="applyStatusFilter('closed')">
        <i class="fa fa-circle circle-offline" aria-hidden="true"></i>
        <p>abgeschlossene Chats ({{ closeCount }})</p>
      </div>
    </div>
</template>

<script>
export default {
  name: 'StatusFilter',
  data() {
    return {
      currentStatusFilter: 'all',
    }
  },
  methods: {
    applyStatusFilter(filterOption) {
      this.currentStatusFilter = filterOption;
      this.$parent.$emit('filter', {data: filterOption, filter: 'status'});
    }
  },
  computed: {
    allClientMessages() {
      return this.$store.getters.getOriginalClientMessages;
    },
    allCount: function () {
      return this.allClientMessages.length;
    },
    openCount: function () {
      return this.allClientMessages.filter(chat => chat.status === 'open').length;
    },
    closeCount: function () {
      return this.allClientMessages.filter(chat => chat.status === 'closed').length;
    },
    processedCount: function () {
      return this.allClientMessages.filter(chat => chat.status === 'processed').length;
    }
  },
}
</script>
